import { defaultApi } from '@/plugins/api/defaultApi'

const status = {
  does_not_exist: 'does_not_exist',
  pending: 'pending',
  in_progress: 'in_progress',
  signed: 'signed',
  completed: 'completed',
  closed: 'closed',
}

const st = {
  name: 'contract',
  namespaced: true,
  state: {
    isContractsLoad: false,
    contracts: [],
    status,
    statusNames: {
      [status.does_not_exist]: '계약서 작성 필요',
      [status.pending]: '대기중',
      [status.in_progress]: '대기중',
      [status.signed]: '서명완료',
      [status.completed]: '계약완료',
      [status.closed]: '해지',
    },
  },
  getters: {
    contractStatus: (state) => (type) => {
      const contracts = state.contracts || []
      let filterContracts
      if (type) {
        filterContracts = contracts.filter((c) => c.mallProviderCode === type)
      } else {
        filterContracts = contracts.filter((c) => c.mallProviderCode == null)
      }

      if (
        filterContracts.find((c) => state.statusNames[c.status] === state.statusNames.in_progress)
      ) {
        return status.in_progress
      } else if (
        filterContracts.find((c) => state.statusNames[c.status] === state.statusNames.pending)
      ) {
        return status.in_progress
      } else if (
        filterContracts.find((c) => state.statusNames[c.status] === state.statusNames.closed)
      ) {
        return status.closed
      }

      return status.completed
    },
    isPending(state) {
      const contracts = state.contracts || []

      return contracts.filter(
        (c) =>
          c.mallProviderCode !== null && ['pending', 'signed', 'in_progress'].includes(c.status),
      )
    },
    isAllCompleted(state) {
      if (!state.isContractsLoad) {
        return false
      }
      const contracts = state.contracts.filter((c) => c.type === 'transfer_agreement_and_notice')

      const completedCount = contracts.filter(
        (c) => c.mallProviderCode !== null && [status.completed, status.closed].includes(c.status),
      ).length

      return contracts.length === completedCount
    },
    isServiceAvailable(state) {
      if (!state.contracts) {
        return false
      }

      const contracts = state.contracts.filter((c) => c.type === 'transfer_agreement_and_notice')
      return contracts.find((c) => c.status === status.completed) ? true : false
    },
  },
  mutations: {
    setIsContractsLoad(state, isContractsLoad) {
      state.isContractsLoad = isContractsLoad
    },
    setContracts(state, contracts) {
      state.contracts = contracts
    },
  },
  actions: {
    async getContracts({ commit }) {
      commit('setIsContractsLoad', false)
      const {
        data: { results },
      } = await defaultApi.getContracts()
      commit('setContracts', results)
      commit('setIsContractsLoad', true)
      return results
    },
    async postContractsStart() {
      await defaultApi.postContractsStart()
      return true
    },
    isCompleted({ getters }, providerCode) {
      return getters.contractStatus(providerCode) === status.completed
    },
    async getContractSecureLink({}, { uuid, redirectUrl }) {
      const { data } = await defaultApi.getContractSecureLink({ uuid, redirectUrl })
      return data
    },
  },
}
export default st
